/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PasswordValidationRuleset } from './PasswordValidationRuleset';
import {
    PasswordValidationRulesetFromJSON,
    PasswordValidationRulesetFromJSONTyped,
    PasswordValidationRulesetToJSON,
} from './PasswordValidationRuleset';

/**
 * 
 * @export
 * @interface PasswordSetChallengeOptions
 */
export interface PasswordSetChallengeOptions {
    /**
     * 
     * @type {PasswordValidationRuleset}
     * @memberof PasswordSetChallengeOptions
     */
    validation_rules: PasswordValidationRuleset;
}

/**
 * Check if a given object implements the PasswordSetChallengeOptions interface.
 */
export function instanceOfPasswordSetChallengeOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "validation_rules" in value;

    return isInstance;
}

export function PasswordSetChallengeOptionsFromJSON(json: any): PasswordSetChallengeOptions {
    return PasswordSetChallengeOptionsFromJSONTyped(json, false);
}

export function PasswordSetChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordSetChallengeOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'validation_rules': PasswordValidationRulesetFromJSON(json['validation_rules']),
    };
}

export function PasswordSetChallengeOptionsToJSON(value?: PasswordSetChallengeOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'validation_rules': PasswordValidationRulesetToJSON(value.validation_rules),
    };
}

